import { useMutation, useQueryClient } from '@tanstack/react-query';

import { blockUser } from '../api/usersApi';
import { ADMIN_USERS_QUERY_KEY } from './useAdminUsers';

// PARA-106, AC-3: инвалидирует ['admin','users'] после успешной блокировки.
export function useBlockUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId: number) => blockUser(userId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_USERS_QUERY_KEY });
    },
  });
}
